
import './App.css';
import LandingPage from '../src/pages/Landingpage';

function App() {
  return (
 <LandingPage/>
  );
}

export default App;
